import { type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'
import { type PackageCategoryEntity } from '@/libs/api'

import { PackageCategoryCreateModalContent } from './PackageCategoryCreateModalContent'

type Props = {
  open: boolean
  tenantKey: string
  onSuccess: (packageCategory: PackageCategoryEntity) => Promise<void>
  onClose: () => void
}

export const PackageCategoryCreateModal: FC<Props> = ({
  open,
  tenantKey,
  onSuccess,
  onClose
}) => {
  return (
    <Modal
      title={MENU.CREATING_PACKAGE_CATEGORY}
      zIndex={1999}
      width={860}
      open={open}
      onCancel={onClose}
    >
      <PackageCategoryCreateModalContent
        tenantKey={tenantKey}
        onSuccess={onSuccess}
        onCancel={onClose}
      />
    </Modal>
  )
}
